import styled from "@emotion/styled";

export const StyledTextAndProof = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;

  .text {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 50px;
  }

  .proof-badges-image {
    height: 110px;
  }
`;
